import styled from 'styled-components';

import { Body } from '../SiteCard/SiteCard.style';

export default styled.div``;

export const Section = styled(Body)`
  border-bottom: 1px solid ${({ theme }) => theme.COLOR_GRAY_LIGHT};
`;
